import { getValidToken } from '@/script/storageToken'
import { checkSentry } from '@/script'
import * as Sentry from '@sentry/vue'
import createAxios from './axios_create'
import axiosRetry from 'axios-retry'
import { config } from '@/script/cache/configuration'
import {MoodleError} from "@/script/moodleErrorHandler";


export const _axios = createAxios({
    baseURL: `${config.url}webservice/restful/server.php`,
    withCredentials: true
    // baseURL: 'http://tumgu-moodle-dev.devpy.ddemo.ru/' + 'webservice/rest/server.php'
})

axiosRetry(
    _axios,
    {
        retryDelay: axiosRetry.exponentialDelay,
        retries: 3,
        retryCondition: (error) => {
            return axiosRetry.isNetworkError(error) || error.response?.status === 500 || error.response?.status === 504
        }
    }
)

const $axios = ({ method, params = {}, data = false }) => {
    let axios_param = {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json'
        }
    }
    if (!!getValidToken()) {
        axios_param.headers.Authorization = `Bearer ${getValidToken()}`
    }

    axios_param.params = { ...params }
    //eslint-disable-next-line
    if (!!data) {
        if (data instanceof FormData) {
            axios_param.data = data

            for (let key of Object.keys(axios_param.params)) {
                axios_param.data.append(key, axios_param.params[key])
            }

            axios_param.headers['Content-Type'] = 'multipart/form-data'
            axios_param.url = data.get('wsfunction')

            data.delete('wsfunction')
        } else {
            axios_param.data = { ...data, ...axios_param.params }
            axios_param.url = axios_param.data.wsfunction

            delete axios_param.data.wsfunction
        }
    } else {
        axios_param.data = { ...axios_param.params }
        axios_param.url = axios_param.data.wsfunction

        delete axios_param.data.wsfunction
    }

    axios_param.params = {}

    const axiosPromise = (span) => _axios(axios_param).then(resp => {
        if (span) {
            span.setAttribute('http.response.status_code', resp.status)
            span.setAttribute(
                'http.response_content_length',
                Number(resp.headers.get('content-length'))
            )
        }

        if (resp.data?.exception) {
            throw new MoodleError(resp.data) // ** break code processing
        } else if (resp.data?.warnings?.length) {
            new MoodleError(resp.data)  // ** register error but not break code processing
        }

        return Promise.resolve(resp)
    }).catch(err => {
        if (err instanceof MoodleError) {
            return Promise.reject(err)
        }

        if (span) {
            span.setAttribute('http.response.status_code', err.status)
        }

        if (err.response.data?.exception) {
            throw new MoodleError(err.response.data) // ** break code processing
        }

        return Promise.reject(err.response)
    })

    if (checkSentry()) {
        let url = import.meta.env.VITE_APP_BASE_API_URL + `webservice/restful/server.php/${axios_param.url}`

        return Sentry.startSpan(
            { op: 'http.client', name: `POST ${url}` },
            (span) => {
                const parsedURL = new URL(url, location.origin)

                span.setAttribute('http.request.method', method)
                span.setAttribute('server.address', parsedURL.hostname)
                span.setAttribute('server.port', parsedURL.port || undefined)

                if (axios_param.data) {
                    for (let key in Object.keys(axios_param.data)) {
                        span.setAttribute(`http.request.${key}`, axios_param.data[key])
                    }
                }

                return axiosPromise(span)
            }
        )
    } else {
        return axiosPromise(null)
    }
}
/**
 * @description Обертка для запросов в moodle
 * @param {String} method POST, GET, PATCH и тд
 * @param {Object} params Объект имеющий обязательное поле  ` wsfunction: <moodle_rest_function> ` - сюда передавать функцию moodle например `core_user_view_user_profile`
 * @param {Object} data
 * @returns
 */
const $axiosUrl = ({ url, params = {}, data = {} }) => {
    let axios_param = {
        url: url,
        method: 'POST',
        params,
        data
    }

    return _axios(axios_param)
        .then(resp => Promise.resolve(resp))
        .catch(err => Promise.reject(err))
}
export { $axiosUrl, $axios }
